import { useCallback } from "react";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { useMappedState } from "redux-react-hook";
import styled from "styled-components";
import Tabs from "ui-kit/Tabs";
import { isBlank } from "utils/storeUtils";

import { USER_INDEX_TABS } from "../../UserRootPage/constants";

interface IHeaderProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  hasBanners?: boolean;
}



const Header: React.FC<IHeaderProps> = (props) => {
  const { activeTab, setActiveTab, hasBanners } = props;
  const charactersListFlag = useFeatureFlag('charactersList');
  const tabs = [
    { tabValue: 'featured-scenarios', label: 'Scenarios' },
  ];

  const characterListOption = { tabValue: 'characters', label: 'Characters' };


  const { currentUser } = useMappedState(
    useCallback(state => ({
      currentUser: state.users.usersMap.get(state.users.currentUserId),
    }), [])
  );

  const hasCurrentUser = !isBlank(currentUser);

  const getTabsByFeatureFlag = (flag: boolean | null, hasCurrentUser: boolean) => {
    if (flag && hasCurrentUser) {
      return [...tabs, characterListOption];
    }
    return tabs;
  };


  return (
    <Root>
      <TabsSection hasBanners={hasBanners} hasCurrentUser={hasCurrentUser} className={'text-white'}>
        <Tabs tabs={getTabsByFeatureFlag(charactersListFlag, hasCurrentUser)} defaultTab={USER_INDEX_TABS.SCENARIOS} activeTab={activeTab} onTabChange={setActiveTab} />
      </TabsSection>
    </Root>
  );
};

export default Header;

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

const TabsSection = styled.div<{ hasBanners?: boolean, hasCurrentUser?: boolean }>`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: ${({ hasBanners, hasCurrentUser }) => (hasBanners || !hasCurrentUser) ? '0px' : '110px'};
  margin-bottom: 20px;

  @media (max-width: 720px) {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 30px;
  }
`;